import { factory, getResponseCamelization } from '@repo-level/core-front';
import type { TournamentBackend } from 'api/tournaments';
import { isCMSV3 } from 'helpers/conf';
import type {
  CMSApiBase,
  CMSGroupParams,
  CMSImageBase,
  CMSOrder,
} from './base';
import { buildCmsUrl, getResponseCMS, LIMIT_500 } from './base';

export type TTournamentBadge =
  | 'win_chances'
  | 'racing_12h'
  | 'racing_24h'
  | 'telegram_special'
  | 'vip_only'
  | 'au_only'
  | 'ca_only'
  | 'de_only'
  | 'nz_only'
  | 'ie_only'
  | 'eu_only'
  | 'new_mechanics'
  | 'le_game';

export interface TournamentBanner {
  prizePool: string;
  title: string;
  minBet?: string;
  minSpins?: string;
  background: CMSImageBase;
  image: CMSImageBase;
  durationFrom: string;
  durationTo: string;
  inHouse?: boolean;
  badge?: TTournamentBadge;
}

export interface HowToWinCard {
  description: string;
  id: number;
  title: string;
}

export interface InfoBadge {
  prizePlaces?: string;
  strategy?: string;
  minBet?: string;
  participation?: string;
}

export interface Tournament extends CMSApiBase, CMSOrder, CMSGroupParams {
  name: string;
  banner: TournamentBanner;
  tc: string;
  collectionName: string;
  backendTournamentId?: string;
  externalWidgetId?: string;
  ssWidgetId?: string;
  cards: HowToWinCard[];
  text?: string;
  icon?: CMSImageBase;
  backendTournament?: TournamentBackend | undefined;
  textIntro?: string;
  infoBadges?: InfoBadge;
}

export const tournamentsV3 = factory(
  (r) => (lang: string) =>
    r<Tournament[]>(
      'get',
      buildCmsUrl({ path: 'tournaments', lang, limit: LIMIT_500 })
    )
);

export const tournamentsV4 = factory(
  (r) => (lang: string) =>
    r<Tournament[]>(
      'get',
      buildCmsUrl({
        path: 'tournaments',
        lang,
        limit: LIMIT_500,
        additionalParams: { populate: 'deep' },
      }),
      undefined,
      { transformResponse: [getResponseCamelization(), getResponseCMS] }
    )
);

export const tournaments = isCMSV3 ? tournamentsV3 : tournamentsV4;
